import { MessageCircle } from 'lucide-react';

const WhatsAppFAB = () => {
  const handleClick = () => {
    const message = encodeURIComponent('Hello! I would like to know more about Chaleur products.');
    window.open(`https://wa.me/918796244314?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
};

export default WhatsAppFAB;
